import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const FloatingContact = () => (
  <motion.div
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-6 right-6 z-40"
  >
    <Link
      to="/contact"
      data-testid="floating-contact-btn"
      aria-label="Contact B&H Truck Dispatching"
      className="relative flex items-center justify-center w-14 h-14 rounded-full bg-gold text-ink shadow-[0_0_30px_rgba(212,175,55,0.5)] hover:bg-champagne transition-colors duration-300"
    >
      <span className="absolute inset-0 rounded-full border border-gold animate-ping opacity-30" />
      <Phone size={22} />
    </Link>
  </motion.div>
);
